import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { IShortLineProfile } from '@ruby/modules/short-line-profile/models/short-line-profile.interface';
import { fromShortLineCore, ShortLineCoreActions } from '@ruby/modules/short-line-profile/store/short-line-core.index';
import { fromShortLineHeader } from '@ruby/modules/short-line-profile/store/short-line-header.index';
import {
  fromShortLineSummary,
  ShortLineSummaryActions,
  ShortLineSummarySelectors
} from '@ruby/modules/short-line-profile/store/short-line-summary.index';
import { IStation } from '@ruby/shared/models/commons/station.interface';

@Component({
  selector: 'ng-commercial-summary-container',
  template: `
    <ng-commercial-summary *ngIf="(store$ | async) as store"
                           [profile]="store.summary.profile"
                           [loading]="store.summary.loading"
                           [isNew]="store.header.profile?.reportingMark === 'Add New Profile'"
                           [canEdit]="store.canEdit"
                           [isAdmin]="store.isAdmin"
                           [loadingCities]="store.core.loadingCity"
                           [loadingSearch]="store.summary.loadingSearch"
                           [isError]="!!store.summary.error"
                           [states]="store.core.states"
                           [cities]="store.core.cities"
                           (loadOriginStationsData)="loadOriginStations($event)"
                           (saveProfile)="update($event)"
                           (createProfile)="create($event)"
                           (searchReportingMark)="search($event)">
    </ng-commercial-summary>
  `
})
export class CommercialSummaryContainer {
  store$!: Observable<{
    summary: fromShortLineSummary.State;
    core: fromShortLineCore.State;
    header: fromShortLineHeader.State;
    canEdit: boolean;
    isAdmin: boolean;
  }>;

  constructor(private store: Store<fromShortLineCore.State>) {
    this.store$ = this.store.select(ShortLineSummarySelectors.selectSummaryState);
    this.store.dispatch(ShortLineCoreActions.loadStates());
  }

  /**
   * Load Origin Stations
   *
   * @summary Called to load the origin and destination
   * @param $event: IStation
   * @returns void
   */
  loadOriginStations($event: IStation): void {
    if ($event.station.length > 2) {
      this.store.dispatch(ShortLineCoreActions.loadDestinationStations({ data: $event }));
    } else {
      this.store.dispatch(ShortLineCoreActions.setDestinationStations({ data: [] }));
    }
  }

  /**
   * Update
   *
   * @summary Called to update a short line profile
   * @param $profile: IShortLineProfile
   * @returns void
   */
  update($profile: IShortLineProfile): void {
    this.store.dispatch(ShortLineSummaryActions.updateProfile({ data: $profile }));
  }

  /**
   * Create
   *
   * @summary Called to create a short line profile
   * @param $profile: IShortLineProfile
   * @returns void
   */
  create($profile: IShortLineProfile): void {
    this.store.dispatch(ShortLineSummaryActions.createProfile({ data: $profile }));
  }

  /**
   * Search
   *
   * @summary Called to search a reporting mark
   * @param $profileId: string
   * @returns void
   */
  search($profileId: string): void {
    this.store.dispatch(ShortLineSummaryActions.searchReportingMark({ data: $profileId }));
  }
}
